module.exports = __webpack_public_path__ + "static/media/heart_sprite_cover_final.7c8891b8.png";